/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * Represents a map of ownership for the different Nft Groupings.
 * @export
 * @interface NftOwnership
 */
export interface NftOwnership {
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    nftTrackerId: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    userId?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    nftId: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    tokenUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    tokenImageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    nftGroupingIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    burnedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    redeemedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    redeemRecord?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    replacedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    replacedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    transactionHash?: string;
    /**
     * 
     * @type {number}
     * @memberof NftOwnership
     */
    nftTrackerIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof NftOwnership
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnership
     */
    isVirtual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnership
     */
    isEligibleForCompetitions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NftOwnership
     */
    ofCurrentCommunity?: boolean;
    /**
     * The type of wallet holding this NFT (THIRDWEB, MAGIC, WALLET_CONNECT, etc.)
     * @type {string}
     * @memberof NftOwnership
     */
    walletType?: string;
    /**
     * The blockchain address of the wallet holding this NFT
     * @type {string}
     * @memberof NftOwnership
     */
    walletAddress?: string;
    /**
     * 
     * @type {NftTracker}
     * @memberof NftOwnership
     */
    tracker?: NftTracker;
}

/**
 * Check if a given object implements the NftOwnership interface.
 */
export function instanceOfNftOwnership(value: object): value is NftOwnership {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('nftTrackerId' in value) || value['nftTrackerId'] === undefined) return false;
    if (!('nftId' in value) || value['nftId'] === undefined) return false;
    return true;
}

export function NftOwnershipFromJSON(json: any): NftOwnership {
    return NftOwnershipFromJSONTyped(json, false);
}

export function NftOwnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftOwnership {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'nftGroupingId': json['nftGroupingId'] == null ? undefined : json['nftGroupingId'],
        'nftTrackerId': json['nftTrackerId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'nftId': json['nftId'],
        'tokenUri': json['tokenUri'] == null ? undefined : json['tokenUri'],
        'tokenImageUrl': json['tokenImageUrl'] == null ? undefined : json['tokenImageUrl'],
        'nftGroupingIndex': json['nftGroupingIndex'] == null ? undefined : json['nftGroupingIndex'],
        'burnedAt': json['burnedAt'] == null ? undefined : json['burnedAt'],
        'redeemedAt': json['redeemedAt'] == null ? undefined : json['redeemedAt'],
        'redeemRecord': json['redeemRecord'] == null ? undefined : json['redeemRecord'],
        'replacedAt': json['replacedAt'] == null ? undefined : json['replacedAt'],
        'replacedBy': json['replacedBy'] == null ? undefined : json['replacedBy'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'nftTrackerIndex': json['nftTrackerIndex'] == null ? undefined : json['nftTrackerIndex'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'isVirtual': json['isVirtual'] == null ? undefined : json['isVirtual'],
        'isEligibleForCompetitions': json['isEligibleForCompetitions'] == null ? undefined : json['isEligibleForCompetitions'],
        'ofCurrentCommunity': json['ofCurrentCommunity'] == null ? undefined : json['ofCurrentCommunity'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'walletAddress': json['walletAddress'] == null ? undefined : json['walletAddress'],
        'tracker': json['tracker'] == null ? undefined : NftTrackerFromJSON(json['tracker']),
    };
}

export function NftOwnershipToJSON(json: any): NftOwnership {
    return NftOwnershipToJSONTyped(json, false);
}

export function NftOwnershipToJSONTyped(value?: NftOwnership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'nftGroupingId': value['nftGroupingId'],
        'nftTrackerId': value['nftTrackerId'],
        'userId': value['userId'],
        'nftId': value['nftId'],
        'tokenUri': value['tokenUri'],
        'tokenImageUrl': value['tokenImageUrl'],
        'nftGroupingIndex': value['nftGroupingIndex'],
        'burnedAt': value['burnedAt'],
        'redeemedAt': value['redeemedAt'],
        'redeemRecord': value['redeemRecord'],
        'replacedAt': value['replacedAt'],
        'replacedBy': value['replacedBy'],
        'transactionHash': value['transactionHash'],
        'nftTrackerIndex': value['nftTrackerIndex'],
        'notes': value['notes'],
        'isVirtual': value['isVirtual'],
        'isEligibleForCompetitions': value['isEligibleForCompetitions'],
        'ofCurrentCommunity': value['ofCurrentCommunity'],
        'walletType': value['walletType'],
        'walletAddress': value['walletAddress'],
        'tracker': NftTrackerToJSON(value['tracker']),
    };
}

